import { useLazyQuery, useQuery } from "@apollo/client";
import { CREATED_SITES } from "../created-site.queries";
import {
  CreatedSitesQuery,
  CreatedSitesQueryVariables,
} from "../../../__generated__/CreatedSitesQuery";

export const useCreatedSites = (variables: CreatedSitesQueryVariables) => {
  return useQuery<CreatedSitesQuery, CreatedSitesQueryVariables>(CREATED_SITES, {
    variables,
  });
};

export const useLazyCreatedSites = () => {
  return useLazyQuery<CreatedSitesQuery, CreatedSitesQueryVariables>(CREATED_SITES);
};
